import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from '../../../model/master/role/role';
import { HttpClient } from '@angular/common/http';
import { LeadType } from 'src/app/model/master/lead-type/LeadType';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LeadTypeService {

  constructor(private http: HttpClient) { }

  public submit(leadType: LeadType): Observable<any[]> {
    // return this.http.post<any[]>("https://krios-growvac.azurewebsites.net/api/LeadType/Insert", leadType);
    return this.http.post<any[]>(`${environment.apiUrl}/LeadType/Insert`, leadType);
  }

  public search(): Observable<any> {
    // return this.http.get<any[]>("https://krios-growvac.azurewebsites.net/api/LeadType");
    return this.http.get<any[]>(`${environment.apiUrl}/LeadType`);
  }

  public update(leadType: LeadType): Observable<any[]> {
    // return this.http.post<any[]>("https://krios-growvac.azurewebsites.net/api/LeadType/Update", leadType);
    return this.http.post<any[]>(`${environment.apiUrl}/LeadType/Update`, leadType);
  }
}
